import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';
import { Resources } from '../../resource';

/** 与 POST /blind-box/reward-feed-usdc 请求体一致：仅 userId / from / to + 分页 */
export function normalizeUsdCRewardFeedBody(filter: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  const uid = String(filter.userId ?? '').trim();
  if (uid) out.userId = uid;
  ['from', 'to'].forEach((k) => {
    const v = filter[k];
    if (v !== '' && v != null && v !== undefined) out[k] = v;
  });
  return out;
}

class UsdcRewardFeedDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== Resources.blindBoxRewardFeedUsdc) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {} } = params;

    const body = normalizeUsdCRewardFeedBody(filter as Record<string, unknown>);
    body.limit = perPage;
    body.offset = (page - 1) * perPage;

    const url = `${baseUrl}/blind-box/reward-feed-usdc`;
    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    const entries = json?.entries ?? [];
    const total = json?.total ?? 0;
    return { data: entries, total };
  }
}

export const dataProvider = new UsdcRewardFeedDataProvider();

registerModuleDataProvider(Resources.blindBoxRewardFeedUsdc, dataProvider);
